// organization-relationship.service.ts
import { OrganizationRelationshipsApi } from '@evimo/client/apis/OrganizationRelationshipsApi';
import { Configuration } from '@evimo/client/runtime';
import type { CreateOrganizationRelationshipRequestDto } from '@evimo/client/models/CreateOrganizationRelationshipRequestDto';
import type { CreateOrganizationRelationshipResponseDto } from '@evimo/client/models/CreateOrganizationRelationshipResponseDto';
import type { UpdateOrganizationRelationshipRequestDto } from '@evimo/client/models/UpdateOrganizationRelationshipRequestDto';

import { KNOWLEDGE_API_URL } from '~/src/constants/env';

const API_BASE = KNOWLEDGE_API_URL;

const api = new OrganizationRelationshipsApi(
  new Configuration({
    basePath: API_BASE,
    credentials: 'include',
  }),
);

export const OrganizationRelationshipService = {
  findAll(): Promise<CreateOrganizationRelationshipResponseDto[]> {
    return api.organizationRelationshipControllerFindAll({
      credentials: 'include',
    });
  },

  findById(id: string): Promise<CreateOrganizationRelationshipResponseDto> {
    return api.organizationRelationshipControllerFindById(
      { id },
      { credentials: 'include' },
    );
  },

  create(
    dto: CreateOrganizationRelationshipRequestDto,
  ): Promise<CreateOrganizationRelationshipResponseDto> {
    return api.organizationRelationshipControllerCreate(
      { createOrganizationRelationshipRequestDto: dto },
      { credentials: 'include' },
    );
  },

  update(
    id: string,
    dto: UpdateOrganizationRelationshipRequestDto,
  ): Promise<void> {
    return api.organizationRelationshipControllerUpdate(
      { id, updateOrganizationRelationshipRequestDto: dto },
      { credentials: 'include' },
    );
  },

  delete(id: string): Promise<void> {
    return api.organizationRelationshipControllerDelete(
      { id },
      { credentials: 'include' },
    );
  },
};
